var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61.12 30.738h-2.654v-9.493c0-3.17-2.579-5.75-5.75-5.75h-2.394l-12.236-13.176c-.377-.407-1.087-.408-1.466 0l-6.481 6.983-6.479-6.983c-.189-.204-.455-.32-.733-.32s-.544.116-.732.319l-12.237 13.178h-2.319c-3.176 0-5.76 2.579-5.76 5.75v34.994c0 3.176 2.584 5.76 5.76 5.76h45.077c3.171 0 5.75-2.584 5.75-5.76v-9.487h2.654c.553 0 1-.448 1-1v-14.015c0-.552-.447-1-1-1zm-29.616-19.966 5.85-6.303 10.239 11.026h-11.708l-.436-.47zm-8.577-6.303 8.43 9.085 1.8 1.94h-20.469l10.239-11.024zm33.539 51.771c0 2.073-1.683 3.76-3.75 3.76h-45.076c-2.073 0-3.76-1.687-3.76-3.76v-34.994c0-2.067 1.687-3.75 3.76-3.75h45.076c2.067 0 3.75 1.682 3.75 3.75v9.493h-11.356c-4.415 0-8.008 3.592-8.008 8.007s3.593 8.008 8.008 8.008h11.356v9.487zm3.654-11.487h-15.011c-3.312 0-6.008-2.695-6.008-6.008s2.695-6.007 6.008-6.007h12.354s.002 0 .002 0 .002 0 .002 0h2.652v12.015z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.872 35.163c-1.977 0-3.585 1.608-3.585 3.585s1.608 3.584 3.585 3.584 3.585-1.608 3.585-3.584-1.608-3.585-3.585-3.585zm0 5.169c-.874 0-1.585-.711-1.585-1.584s.711-1.585 1.585-1.585 1.585.711 1.585 1.585-.711 1.584-1.585 1.584z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.46d478b983135587b55846651e7d5e46.svg";
export { ForwardRef as ReactComponent };